import React from 'react'
import ProductDetails from './ProductDetails'

const ProductPageSidebar = ({ productData, brandCat, productSettings }) => {
   return (
      <div className="col-lg-5 d-none d-lg-block ps-0 pr-128 product-details">
         <div className="productpage-details-desktop p-32">
            <ProductDetails
               productSettings={productSettings}
               productData={productData}
               brandCat={brandCat}
            ></ProductDetails>
         </div>
      </div>
   )
}

export default ProductPageSidebar